import { IFrontendSettingsState } from './states';
import { createReducer, on } from '@ngrx/store';
import * as Actions from './actions';

export const initialState: IFrontendSettingsState = {
  isLoading: false,
  frontendSettings: null,
  error: null,
};

export const frontendSettingsReducers = createReducer(
  initialState,
  on(Actions.getFrontendSettings, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(Actions.getFrontendSettingsSuccess, (state, action) => ({
    ...state,
    isLoading: false,
    frontendSettings: action.frontendSettings,
  })),
  on(Actions.getFrontendSettingsFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(Actions.updateSettings, (state, { customSettings }) => ({
    ...state,
    frontendSettings: {
      ...state.frontendSettings,
      customSettings: {
        ...state.frontendSettings.customSettings,
        ...customSettings,
      },
    },
  }))
);
